<template>
<div class="chapter">
<div class="inner_page">
<section class="minitoc notoc" data-pdf-bookmark="Mini TOC" data-type="preface" epub:type="preface"><div class="preface" id="d13e19"><h1 class="ChapTitleNonprintingctnp" data-displayheader="no"><span href="#/toc01" title="Link target outside of Sample">Mini TOC</span></h1>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><a class="spanhyperlinkurl" href="#/dedication01#d1e439" id="beginreading">Begin Reading</a></p>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><span class="spanhyperlinkurl" href="#/toc01#z_TOC" id="toc" title="Link target outside of Sample">Table of Contents</span></p>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><span class="spanhyperlinkurl" href="#/app01#d1e4816" id="abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><a class="spanhyperlinkurl" href="#/copyrightpage01#d1e316" id="copyright-page">Copyright Page</a></p></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface01.vue?08e00d3e